/**
 * 팀 API 클라이언트
 */

import apiClient from './client';

export type TeamStatus = 'active' | 'inactive';

export interface Team {
  id: string;
  name: string;
  customerId: string;
  tenantId: string;
  description?: string;
  status: TeamStatus;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateTeamInput {
  name: string;
  customerId: string;
  tenantId: string;
  description?: string;
  status?: TeamStatus;
}

export const teamApi = {
  async list(): Promise<Team[]> {
    const res = await apiClient.get<{ success: boolean; data: Team[] }>('/api/teams');
    return res.data.data;
  },
  async listByCustomer(customerId: string): Promise<Team[]> {
    const res = await apiClient.get<{ success: boolean; data: Team[] }>('/api/teams', {
      params: { customerId },
    });
    return res.data.data;
  },
  async create(input: CreateTeamInput): Promise<Team> {
    const res = await apiClient.post<{ success: boolean; data: Team }>('/api/teams', input);
    return res.data.data;
  },
  async update(id: string, input: { name?: string; description?: string; status?: TeamStatus }): Promise<Team> {
    const res = await apiClient.patch<{ success: boolean; data: Team }>(`/api/teams/${id}`, input);
    return res.data.data;
  },
  async remove(id: string): Promise<void> {
    await apiClient.delete(`/api/teams/${id}`);
  },
};
